import { Config } from './Config';

export const ABUtils = {
    getABs: () => Config.get('ab'),
};
